var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-button",
        {
          staticStyle: { "margin-left": "8px" },
          attrs: { type: "primary", icon: "download" },
          on: { click: _vm.ExportXls }
        },
        [_vm._v("导出")]
      ),
      _c(
        "a-tabs",
        {
          attrs: { "hide-add": "", "active-key": _vm.activeKey },
          on: { click: _vm.handleClickTab }
        },
        _vm._l(_vm.FloorAreaList, function(pane) {
          return _c(
            "a-tab-pane",
            {
              key: pane.sysfloorid,
              attrs: { tab: pane.floorname, closable: pane.closable }
            },
            [
              _c("div", { staticClass: "main" }, [
                _c(
                  "div",
                  {
                    staticClass: "main-content",
                    on: {
                      mousedown: _vm.down,
                      mousemove: _vm.move,
                      mouseup: _vm.up
                    }
                  },
                  [
                    _vm._l(_vm.areas, function(area, index1) {
                      return _c(
                        "div",
                        {
                          key: index1,
                          staticClass: "areaheader",
                          style: { with: area.maxRowQty * 52 + "px" }
                        },
                        [_vm._v(_vm._s(area.areaname))]
                      )
                    }),
                    _vm._l(_vm.area.seats, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "list" },
                        [
                          _c("div", { staticClass: "colno" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._l(item, function(val, pk) {
                            return _c(
                              "div",
                              { key: pk, staticClass: "oplist" },
                              [
                                index == 0
                                  ? _c("div", { staticClass: "rowno" }, [
                                      _vm._v(
                                        _vm._s(pk + 1) +
                                          "\n                                "
                                      )
                                    ])
                                  : _vm._e(),
                                val.status === "0"
                                  ? _c("div", {
                                      staticClass: "selection ",
                                      style: {
                                        border: _vm.bordersize + val.sgroupcolor
                                      }
                                    })
                                  : val.status === "1" || val.status === "2"
                                  ? _c("div", {
                                      staticClass: "emptyseat",
                                      style: {
                                        border: _vm.bordersize + val.sgroupcolor
                                      }
                                    })
                                  : val.status === "3"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "selection green",
                                        style: {
                                          border:
                                            _vm.bordersize + val.sgroupcolor
                                        }
                                      },
                                      [_vm._v(_vm._s(val.personname))]
                                    )
                                  : val.status === "4"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "selection yellow",
                                        style: {
                                          border:
                                            _vm.bordersize + val.sgroupcolor
                                        }
                                      },
                                      [_vm._v(_vm._s(val.personname))]
                                    )
                                  : _c("div", {
                                      staticClass: "selection red",
                                      style: {
                                        border: _vm.bordersize + val.sgroupcolor
                                      }
                                    })
                              ]
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              ])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }